import qs from 'qs';
import axios from 'axios';
import Jsona from 'jsona';

const url = process.env.VUE_APP_API_BASE_URL;
const jsona = new Jsona();

function list (params) {
    const options = {
        params: params,
        paramsSerializer: function (params) {
            return qs.stringify(params, { encode: false });
        }
    };

    return axios.post(`${url}/dashboard/data`, options)
        .then(response => {
            return {
                list: jsona.deserialize(response.data),
                meta: response.data.meta
            };
        });
}

function display () {
    const options = {
        headers: {
            'Accept': 'application/vnd.api+json',
            'Content-Type': 'application/vnd.api+json',
        }
    };

    return axios.post(`${url}/dashboard/data`, options)
        .then(response => {
            let myDashboard = jsona.deserialize(response.data);
            delete myDashboard.links;
            return myDashboard;
        });
}

function add (item) {
    const payload = jsona.serialize({
        stuff: item,
        includeNames: ['categories']
    });

    const options = {
        headers: {
            'Accept': 'application/vnd.api+json',
            'Content-Type': 'application/vnd.api+json',
        }
    };

    return axios.post(`${url}/items?include=category,tags`, payload, options)
        .then(response => {
            return jsona.deserialize(response.data);
        });
}

function update (item) {
    const payload = jsona.serialize({
        stuff: item,
        includeNames: []
    });

    const options = {
        headers: {
            'Accept': 'application/vnd.api+json',
            'Content-Type': 'application/vnd.api+json',
        }
    };

    return axios.patch(`${url}/items/${item.id}?include=category,tags`, payload, options)
        .then(response => {
            return jsona.deserialize(response.data);
        });
}

function destroy (id) {
    const options = {
        headers: {
            'Accept': 'application/vnd.api+json',
            'Content-Type': 'application/vnd.api+json',
        }
    };

    return axios.delete(`${url}/items/${id}`, options);
}

function upload (item, image) {
    const bodyFormData = new FormData();
    bodyFormData.append('attachment', image);

    return axios.post(`${url}/uploads/items/${item.id}/image`, bodyFormData)
        .then(response => {
            return response.data.url;
        });
}

/**
 * Get vendor dashboard statistics
 * @param {Object} params - Query parameters (start_date, end_date, vendor_id)
 */
function getVendorStats(params) {
    let options = {
        params: params,
        paramsSerializer: function (params) {
            return qs.stringify(params, { encode: false });
        },
        headers: {
            'Accept': 'application/vnd.api+json',
            'Content-Type': 'application/vnd.api+json',
        }
    };

    return axios.get(`${url}/dashboard/vendor`, options)
        .then(response => {
            let data = jsona.deserialize(response.data);
            return data;
        });
}

/**
 * Get department dashboard statistics
 * @param {Object} params - Query parameters (start_date, end_date, department_id)
 */
function getDepartmentStats(params) {
    let options = {
        params: params,
        paramsSerializer: function (params) {
            return qs.stringify(params, { encode: false });
        },
        headers: {
            'Accept': 'application/vnd.api+json',
            'Content-Type': 'application/vnd.api+json',
        }
    };

    return axios.get(`${url}/dashboard/department`, options)
        .then(response => {
            let data = jsona.deserialize(response.data);
            return data;
        });
}

/**
 * Get port dashboard statistics
 * @param {Object} params - Query parameters (start_date, end_date, port_id)
 */
function getPortStats(params) {
    let options = {
        params: params,
        paramsSerializer: function (params) {
            return qs.stringify(params, { encode: false });
        },
        headers: {
            'Accept': 'application/vnd.api+json',
            'Content-Type': 'application/vnd.api+json',
        }
    };
console.log(options);
    return axios.get(`${url}/dashboard/port`, options)
        .then(response => {
            let data = jsona.deserialize(response.data);
            return data;
        });
}

/**
 * Get admin dashboard statistics
 * @param {Object} params - Query parameters (start_date, end_date)
 */
function getAdminStats(params) {
    let options = {
        params: params,
        paramsSerializer: function (params) {
            return qs.stringify(params, { encode: false });
        },
        headers: {
            'Accept': 'application/vnd.api+json',
            'Content-Type': 'application/vnd.api+json',
        }
    };

    return axios.get(`${url}/dashboard/admin`, options)
        .then(response => {
            let data = jsona.deserialize(response.data);
            return data;
        });
}

/**
 * Get today's dashboard statistics
 * @param {Object} params - Query parameters (date)
 */
function getTodayStats(params) {
    let options = {
        params: params,
        paramsSerializer: function (params) {
            return qs.stringify(params, { encode: false });
        },
        headers: {
            'Accept': 'application/vnd.api+json',
            'Content-Type': 'application/vnd.api+json',
        }
    };

    return axios.get(`${url}/dashboard/today`, options)
        .then(response => {
            let data = jsona.deserialize(response.data);
            return data;
        });
}

/**
 * Resolve an alert
 * @param {string|number} alertId - The alert ID to resolve
 */
function resolveAlert(alertId) {
    const options = {
        headers: {
            'Accept': 'application/vnd.api+json',
            'Content-Type': 'application/vnd.api+json',
        }
    };

    return axios.post(`${url}/dashboard/alerts/${alertId}/resolve`, {}, options)
        .then(response => {
            return response.data;
        });
}

/**
 * Get activity logs
 * @param {Object} params - Query parameters (limit, type, department_id)
 */
function getActivityLogs(params) {
    let options = {
        params: params,
        paramsSerializer: function (params) {
            return qs.stringify(params, { encode: false });
        },
        headers: {
            'Accept': 'application/vnd.api+json',
            'Content-Type': 'application/vnd.api+json',
        }
    };

    return axios.get(`${url}/dashboard/activity-logs`, options)
        .then(response => {
            let data = jsona.deserialize(response.data);
            return data;
        });
}

/**
 * Export dashboard report
 * @param {Object} params - Query parameters (type, format, start_date, end_date)
 */
function exportReport(params) {
    let options = {
        params: params,
        paramsSerializer: function (params) {
            return qs.stringify(params, { encode: false });
        },
        responseType: 'blob',
        headers: {
            'Accept': 'application/json',
        }
    };

    return axios.get(`${url}/dashboard/export`, options)
        .then(response => {
            return response.data;
        });
}

export default {
    list,
    display,
    add,
    update,
    destroy,
    upload,
    getVendorStats,
    getDepartmentStats,
    getPortStats,
    getAdminStats,
    getTodayStats,
    resolveAlert,
    getActivityLogs,
    exportReport
};

